import React from "react";
import { useHistory } from "react-router-dom";
import { registerAPI } from "../../Services/authService.js";
import GoogleSignIn from "./GoogleSignIn";
import useAuthStore from "../../Store/AuthStore.jsx";
import { fetchAndSendSavedProductsToApi } from "../../Utils/ProductUtil.jsx";
import { encodeSearchText } from "../../Utils/urlEncoder.js";
import { Form, SmartFormField, SubmitButton } from "../ui/Form";
import { registerSchema } from "../../schemas/authSchema";
import { useTranslation } from "react-i18next";

const SignUp = ({ setIsSignIn }) => {
  const { t } = useTranslation();
  const login = useAuthStore((state) => state.login);
  const history = useHistory();

  const handleSignup = async (data, { setFormError }) => {
    const response = await registerAPI(data.email, data.password);

    if (response.status === 409) {
      throw new Error("Email already exists. Please use a different email.");
    }

    const token = await response.json();
    window.localStorage.setItem("token", token.token);
    window.localStorage.setItem("email", data.email);
    localStorage.setItem("loggedin", JSON.stringify(true));
    await login(data.email, token.token, true);
    fetchAndSendSavedProductsToApi();

    // Check if we have a stored search query from an unauthenticated user
    const unauthUserSearchText = localStorage.getItem("unauthUserSearchText");
    if (unauthUserSearchText) {
      const encodedSearchText = encodeSearchText(unauthUserSearchText);
      history.push(`/search?query=${encodedSearchText}`);
    } else {
      history.push("/search");
    }
  };

  return (
    <div className="w-full max-w-md space-y-8">
      <div>
        <h2 className="mt-6 text-center text-3xl font-bold text-neutral-green-900">
          {t("career.createAccount")}
        </h2>
        <p className="mt-2 text-center text-sm text-neutral-green-600">
          {t("career.signUpGoogle")}
        </p>
      </div>
      <div className="space-y-4">
        <GoogleSignIn />
      </div>
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-neutral-green-300" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="bg-grey-100 px-2 text-neutral-green-600">
            {t("career.orContinueWith")}
          </span>
        </div>
      </div>
      <div className="space-y-6">
        <Form
          schema={registerSchema}
          onSubmit={handleSignup}
          defaultValues={{ email: "", password: "", confirmPassword: "" }}
          className="space-y-4"
        >
          <SmartFormField
            name="email"
            label={t("career.email")}
            type="email"
            required
            inputProps={{
              placeholder: "m@example.com", variant: "box",
            }}
          />

          <SmartFormField
            name="password"
            label={t("career.password")}
            type="password"
            required
            inputProps={{
              placeholder: t("career.password"), variant: "box",
            }}
          />

          <SmartFormField
            name="confirmPassword"
            label={t("career.confirmPassword")}
            type="password"
            required
            inputProps={{
              placeholder: t("career.confirmPassword"), variant: "box",
            }}
          />

          <SubmitButton
            variant="primary"
            size="md"
            fullWidth
            className="mt-4"
          >
            {t("career.signUp")}
          </SubmitButton>

          <p className="text-sm text-neutral-green-700 mt-4 text-center">
            {t("career.agreeTo")}{" "}
            <a href="/terms" className="text-red-500 underline">
              {t("career.termsAndConditions")}
            </a>{" "}
            {t("career.and")}{" "}
            <a href="/privacy" className="text-red-500 underline">
              {t("career.privacyStatements")}
            </a>
            .
          </p>
        </Form>
      </div>
      <div className="flex items-center justify-center">
        <div className="text-sm">
          {t("career.alreadyHaveAccount")}{" "}
          <a
            href="#"
            className="font-medium text-red-600 hover:underline"
            onClick={(e) => {
              e.preventDefault();
              setIsSignIn(true);
            }}
          >
            {t("career.signIn")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default SignUp;